import React from "react";
import { Dropdown } from "react-bootstrap";
import { PieChart, Settings, User } from "react-feather";
import { Button } from "react-bootstrap";

import avatar1 from "../../assets/img/avatars/avatar.jpg";

const NavbarLogin = () => {
  return (
    <a href="/auth/sign-in">
      <Button type="submit" variant="primary" size="lg" className="btn m-auto">
        Login
      </Button>
    </a>
  );
};

export default NavbarLogin;
